// 毫秒转换时间戳 格式：2020.01.01 00:12
function fTime(date: any) {
  const time = new Date(date);
  if (String(date).length == 13) {
    const f: any = time.getFullYear();
    let mon: any = time.getMonth() + 1;
    mon = mon < 10 ? "0" + mon : mon;
    let d: any = time.getDate();
    d = d < 10 ? "0" + d : d;
    let h: any = time.getHours();
    h = h < 10 ? "0" + h : h;
    let m: any = time.getMinutes();
    m = m < 10 ? "0" + m : m;
    let s: any = time.getSeconds();
    s = s < 10 ? "0" + s : s;
    return `${f}-${mon}-${d} ${h}:${m}:${s}`;
  } else {
    // 转换为毫秒
    return new Date(date).getTime();
  }
}
export default fTime;
